function useQuery(location, paramNames) {
  const searchParams = new URLSearchParams(location.search);
  return paramNames.map(n => searchParams.get(n));
}

export { useQuery };
